import { BUNDLE_PRICING_TYPE, ServiceItemData } from '@/types/bundle'
import { Category } from '@/types/category'
import { Service } from '@/types/service'

interface CalculatePropotionalDiscountProps {
  totalPrice: number
  totalOriginPrice: number
  items: ServiceItemData[]
}

export const calculatePropotionalDiscount = ({
  totalPrice = 0,
  items,
  totalOriginPrice = 0,
}: CalculatePropotionalDiscountProps) => {
  if (!totalPrice) {
    return items
  }
  const itemsWithRatio = items.map((el) => ({
    ...el,
    ratio: el.price / totalOriginPrice,
  }))

  let totalPriceWithRatio = 0
  itemsWithRatio.forEach((el) => {
    totalPriceWithRatio += Math.floor(el.ratio * totalPrice)
  })
  if (totalPriceWithRatio === totalPrice) {
    return itemsWithRatio.map((el) => {
      return {
        ...el,
        priceDiscount: Math.floor(el.ratio * totalPrice),
      }
    })
  }

  let totalPriceToZero = totalPrice
  const formated = itemsWithRatio.map((el, i) => {
    const priceDiscount = Math.floor(el.ratio * totalPrice)
    const lastItem = itemsWithRatio.length - 1 === i
    totalPriceToZero -= priceDiscount
    const safeDiscountPriceDiscount = lastItem
      ? totalPriceToZero + priceDiscount
      : priceDiscount
    return {
      ...el,
      priceDiscount: safeDiscountPriceDiscount || 0,
    }
  })
  return formated
}

export const getServiceWithPrice = ({
  bundleItems,
  services,
  categories,
}: {
  bundleItems: {
    serviceId: string
    variantId: string
  }[]
  services?: Service[]
  categories?: Category[]
}) => {
  const items: ServiceItemData[] = []
  bundleItems.forEach((data) => {
    const serviceDetail = services?.find((el) => el.id === data.serviceId)
    if (serviceDetail) {
      const variantDetail = serviceDetail.variants.find(
        (el) => el.id === data.variantId,
      )
      if (variantDetail) {
        const categoryDetail = categories?.find(
          (el) => el.id === serviceDetail.categoryId,
        )
        items.push({
          name: `${serviceDetail.name}${
            variantDetail.name ? ` - ${variantDetail.name}` : ''
          }`,
          duration: variantDetail.duration,
          price: variantDetail.price,
          color: categoryDetail?.color || '',
          serviceId: data.serviceId,
          variantId: data.variantId,
          priceDiscount: 0,
        })
      }
    }
  })
  return items
}

export const getTotalPriceBundle = ({
  items,
  pricingType,
  fixPrice = 0,
  percentage = 0,
}: {
  items: ServiceItemData[]
  pricingType: BUNDLE_PRICING_TYPE
  percentage: number
  fixPrice: number
}) => {
  const totalOriginPrice = items.reduce((acc, el) => acc + el.price, 0)
  let totalPriceAfterDiscount = 0

  if (pricingType === BUNDLE_PRICING_TYPE.Values.PERCENTAGE) {
    items.forEach((data) => {
      const priceDiscount = (data.price / 100) * (percentage || 0)
      totalPriceAfterDiscount += data.price - priceDiscount
    })
  } else if (pricingType === BUNDLE_PRICING_TYPE.Values.FIX) {
    totalPriceAfterDiscount = fixPrice || 0
  }
  return { totalOriginPrice, totalPriceAfterDiscount }
}
